import rivets from 'rivets';
import BaseView from '../../core/baseView';
import AddressCheckAddressModel from './addressCheckAddressModel';
import AddressCheckPopOver from './addressCheckPopOverView';

export default BaseView.extend({
    selectors: {},

    events: {
        'click .address-finder-list li': 'onClickNewAddressItem',
        'click .close': 'onClickCloseIcon'
    },

    viewModel: null,

    initialize: function (options) {
        this.viewModel = options.viewModel;
        this.addressCheckPopover = new AddressCheckPopOver(options.parentScope.$el.find('[name=street]'), { placement: 'left' });
    },

    destroy: function () {
        // COMPLETELY UNBIND THE VIEW
        if (this._rivetsView) {
            this._rivetsView.unbind();
        }
        this.undelegateEvents();
        this.$el.removeData().unbind();
        this.stopListening();
        this.remove();
        this.hideAddressFinderPopup();
    },

    showDialog: function (viewModel, callback, scope) {

        this.viewModel = viewModel;
        this.parentCallback = callback;
        this.parentScope = scope;
        this.viewModel.set(
            'addresses',
            this._highlightDifferencesInFullAddresses(viewModel.get('addresses'), viewModel.get('ownAddress'))
        );

        if (!this._rivetsView) {
            this._rivetsView = rivets.bind(
                this.$el, {
                    model: this.viewModel
                }
            );
        }

        this.addressCheckPopover.show();
    },
    onClickNewAddressItem: function (e) {
        var selectedRecord = $(e.currentTarget);

        this.parentCallback.call(this.parentScope, this.getSelectedAddress(selectedRecord));
        this.addressCheckPopover.hide();
    },

    onClickCloseIcon: function () {
        this.hideAddressFinderPopup();
    },

    hideAddressFinderPopup: function () {
        if (this.addressCheckPopover) {
            this.addressCheckPopover.hide();
        }
    },

    getSelectedAddress: function (selectedRecord) {
        return this._getAddress(selectedRecord);
    },

    _getAddress: function (selectedRecord) {
        return new AddressCheckAddressModel({
            street: selectedRecord.find('[name=street]').text().trim(),
            streetAdd: selectedRecord.find('[name=streetAdd]').text().trim(),
            zip: selectedRecord.find('[name=zip]').text().trim(),
            city: selectedRecord.find('[name=city]').text().trim()
        });
    },

    _highlightDifferencesInFullAddresses: function (addresses, ownAddress) {
        var i;
        var length;
        var c;
        var address;
        var compareKey;
        var component;
        var compareKeys = ['street', 'streetAdd', 'zip', 'city'];

        for (i = 0, length = addresses.length; i < length; i++) {
            address = addresses[i];

            for (c = 0; c < compareKeys.length; c++) {
                compareKey = compareKeys[c];
                component = address.get(compareKey);

                // compare each component (representation value of compareKey) with own address
                if (component !== ownAddress.get(compareKey)) {
                    address.set(compareKey, address.get(compareKey).replace(component, '<span class="corrected">' + component + '</span>'));
                } else {
                    address.set(compareKey, address.get(compareKey));
                }
            }
        }

        return addresses;
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/helpers/addressCheck/addressCheckView.js
 **/